<div class="row">
  <div class="col-md-6">
    <h1>
      <span *ngIf="!editData">Crear contrato</span
      ><small *ngIf="editData">Editando contrato #{{ editData.id }}</small>
    </h1>
  </div>
  <div class="col-md-6">
    <!-- <app-add-company></app-add-company> -->
  </div>
</div>
<form *ngIf="contract" [formGroup]="contract" class="form-horizontal">
  <div class="row">
    <div class="col-md-8 mb-4">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div
              [class]="myRadio === 'si' ? 'col-md-12' : 'col-md-6'"
              *ngIf="!isMultiplePolicies"
            >
              <label class="form-labels mt-4">Sucursal </label>
              <select
                [(ngModel)]="selectedCompany"
                [ngModelOptions]="{ standalone: true }"
                (change)="updateCompany()"
                [disabled]="!!sucAgency"
                class="form-select"
              >
                <option>-</option>
                <option *ngFor="let agency of agencies" [ngValue]="agency">
                  {{ agency.complete_name }}
                </option>
              </select>
            </div>
            <div *ngIf="myRadio === 'no'" class="col-md-6">
              <label class="form-labels mt-4">Compañia / Sucursal</label>
              <select
                [(ngModel)]="selectedBranch"
                [ngModelOptions]="{ standalone: true }"
                class="form-select"
                (change)="updateBranch()"
              >
                <option selected>-</option>
                <option *ngFor="let company of companies" [ngValue]="company">
                  {{ company.complete_name }}
                </option>
              </select>
              <div class="invalid-feedback" *ngIf="isInvalid('contractType')">
                Campo requerido.
              </div>
            </div>
            <div class="col-md-12 d-flex">
              
              <div class="col-md-4" style="margin-right: 0.5rem;">
                <label class="form-labels mt-4">Tipo de Contrato</label>
                <select class="form-select" formControlName="contractType">
                  <option selected value="">-</option>
                  <option value="personal">Personal</option>
                  <option value="commercial">Comercial</option>
                </select>
                <div class="invalid-feedback" *ngIf="isInvalid('contractType')">
                  Campo requerido.
                </div>
              </div>

                <div class="col-md-2">
                  <label class="form-labels mt-4">Prefijo</label>
                  <select
                    class="form-control"
                    formControlName="policyPrefix"
                    [class.is-invalid]="isInvalid('policyPrefix')"
                  >
                    <option [ngValue]="null">-</option>
                    <option
                      *ngFor="let prefix of prefixOptions"
                      [ngValue]="prefix">
                      {{ prefix.name }} 
                    </option>
                  </select>
                </div>

                <p style="align-content: end; margin-bottom: 9px">-</p>
                <div class="col-md-4">
                  <label class="form-labels mt-4 d-flex align-items-center gap-1">
                    <span>Número de Póliza</span>
                    <span
                      *ngIf="policyLoading"
                      class="spinner-border policy-spinner"
                      role="status"
                      aria-label="Buscando póliza"
                    ></span>
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    aria-label="policy"
                    formControlName="policyNumber"
                    [class.is-invalid]="isInvalid('policyNumber')"
                  />
                </div>
            </div>
            <div class="col-md-12 mt-2" *ngIf="!isUSVI">
              <button
                type="button"
                class="btn btn-primary"
                (click)="findPolicy()"
                [disabled]="policyLoading"
              >
                Buscar Póliza
              </button>
            </div>

            <!-- <div *ngIf="myRadio === 'no'" class="col-md-6">
                <label class="form-labels mt-4">Invoice (opcional)</label>
                <input
                  type="text"
                  class="form-control"
                  aria-label="policy"
                  (input)="findPolicy()"
                  formControlName="invoice"
                />
              </div> -->
            <div
              class="col-md-12"
              *ngIf="policyFound && policyFound.id && !policyUpdated"
            >
              <input
                (click)="addPartner()"
                class="btn btn-primary mt-4 w-100"
                [value]="'Asegurado encontrado: ' + policyFound.name"
              />
            </div>

            <div class="col-md-12">
              <label class="form-labels mt-4"
                >¿Este contrato tendra multiples polizas?</label
              ><br />
              <div class="form-check form-check-inline mt-1">
                <input
                  class="form-check-input"
                  type="radio"
                  value="si"
                  name="select"
                  (change)="checkMultiPolicy($event)"
                  [(ngModel)]="myRadio"
                  [ngModelOptions]="{ standalone: true }"
                />
                <label class="form-check-label">Si</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  name="select"
                  type="radio"
                  value="no"
                  (change)="checkMultiPolicy($event)"
                  [(ngModel)]="myRadio"
                  [ngModelOptions]="{ standalone: true }"
                />
                <label class="form-check-label">No</label>
              </div>
            </div> 

            <div *ngIf="myRadio === 'si'" class="col-md-12">
              {{contract.get('contractType')?.value}}
              <app-multi-policies
                [pronto]="pronto"
                [editPoliciesJson]="policiesJson"
                [prefixOptions]="prefixOptions"
                [allPrefixOptions]="allPrefixOptions"
                [balance]="
                  primaValue || (this.quoteData && this.quoteData.premium)
                "
                [companyId]="selectedCompany?.id"
                (formReady)="addChildForm('policiesJson', $event)"
                [policyFound]="policyFound"
                [policyNum]="contract.get('policyNumber')?.value || null"
                [selectedPolicyPrefix]="policyPrefix"
                [selectedCompany]="selectedBranch || null"
                [selectedPolicyType]="contract.get('contractType')?.value || null"
              >
              </app-multi-policies>
            </div>
            <div class="col-md-6" *ngIf="userRole == 'admin'">
              <label class="form-labels mt-4">Productor</label>
              <select
                [(ngModel)]="selectedProducer"
                [ngModelOptions]="{ standalone: true }"
                (change)="updateProducer()"
                class="form-select"
              >
                <option selected></option>
                <option [ngValue]="producer" *ngFor="let producer of producers">
                  {{ producer.fullname }}
                </option>
              </select>
            </div>

            <!-- Warning message for non-USVI companies when policy is not found -->
            <div *ngIf="!isUSVI && !shouldShowInsuredForm" class="col-md-12 mt-4">
              <div class="alert alert-warning" role="alert">
                <strong>Atención:</strong> Debe buscar una póliza válida para continuar creando el contrato.
                Ingrese el prefijo y número de póliza arriba y presione el botón "Buscar".
              </div>
              <div *ngIf="policyNotFoundMessage" class="alert alert-danger" role="alert">
                {{ policyNotFoundMessage }}
              </div>
            </div>

            <div [style.display]="shouldShowInsuredForm ? 'contents' : 'none'">
            <div class="col-md-12 mt-4">
              <hr />
              <h5>Información de asegurado</h5>
            </div>
            <div class="col-md-6">
              <label class="form-labels mt-4">Nombre</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="insName"
                  [class.is-invalid]="isInvalid('insName')"
                />
              </div>
            </div>
            <div class="col-md-6">
              <!-- <span style="color: rgb(190, 0, 0);">*</span> -->
              <label class="form-labels mt-4">Email</label>
              <div class="input-group">
                <input
                  type="email"
                  class="form-control"
                  formControlName="insEmail"
                  [class.is-invalid]="isInvalid('insEmail')"
                />
              </div>
              <div *ngIf="emailFormatError">
                <span style="color:red">Formato del email: ejemplo@ejemplo.com</span>
              </div>
            </div>
            <div class="col-md-6">
              <label class="form-labels mt-4">Número de Celular</label>
              <div class="input-group">
                <input
                  type="tel"
                  class="form-control"
                  formControlName="insCellphone"
                  [brmasker]="{ mask: '(000) 000-0000', type: 'num' }"
                  maxlength="14"
                  [class.is-invalid]="isInvalid('insCellphone')"
                />
              </div>
            </div>
            <div class="col-md-6">
              <label class="form-labels mt-4">Otro número</label>
              <div class="input-group">
                <input
                  type="tel"
                  class="form-control"
                  formControlName="insOtherphone"
                  [brmasker]="{ mask: '(000) 000-0000', type: 'num' }"
                  maxlength="14"
                />
              </div>
              <div *ngIf="contract.errors?.['atLeastOnePhone'] && (contract.get('insCellphone')?.touched || contract.get('insOtherphone')?.touched)">
                <span style="color:red">Debe ingresar al menos un teléfono.</span>
              </div>
            </div>
            <div class="col-md-12 mt-4">
              <h6>Dirección Fisica</h6>
            </div>
            <div class="col-md-6">
              <label class="form-labels mt-4">Dirección linea 1</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="physicalAddress1"
                  [class.is-invalid]="isInvalid('physicalAddress1')"
                />
              </div>
            </div>
            <div class="col-md-6">
              <label class="form-labels mt-4">Dirección linea 2</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="physicalAddress2"
                />
              </div>
            </div>
            <div class="col-md-6">
              <label class="form-labels mt-4">Ciudad</label>
              <div class="input-group">
                <div style="position: relative; width:100%">
                  <input
                    type="text"
                    class="form-control"
                    formControlName="physicalCity"
                    [class.is-invalid]="isInvalid('physicalCity')"
                    (input)="onCityInputChange($any($event.target).value)"
                    (focus)="onCityInputChange(contract.get('physicalCity')?.value || '')"
                    (blur)="hideCityDropdown()"
                    placeholder="Buscar ciudad..."
                    autocomplete="off"
                  />
                  <ul
                    *ngIf="showCityDropdown && filteredCities.length > 0"
                    class="dropdown-menu show"
                    style="position: absolute; top: 100%; left: 0; right: 0; max-height: 200px; overflow-y: auto; z-index: 1000;"
                  >
                    <li
                      *ngFor="let city of filteredCities"
                      class="dropdown-item"
                      style="cursor: pointer;"
                      (mousedown)="selectCity(city)"
                    >
                      {{ city.Nombre }}
                    </li>
                  </ul>
                </div>
                <div class="invalid-feedback" *ngIf="isInvalid('physicalCity')">
                  Campo requerido.
                </div>
              </div>
            </div>
            <div class="col-md-4" style="display: none;">
              <label class="form-labels mt-4">Estado</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="postalState"
                  maxlength="2"
                  (change)="updatePhysicalState()"
                  [class.is-invalid]="isInvalid('postalState')"
                />
              </div>
            </div>
            <div class="col-md-4">
              <label class="form-labels mt-4">Estado</label>
              <select class="form-select" formControlName="stateCode">
                <option *ngFor="let state of stateCodes" [value]="state.code">
                  {{ state.code }} - {{ state.name }}
                </option>
              </select>
            </div>
            <div class="col-md-4">
              <label class="form-labels mt-4">Zip Code</label>
              <div class="input-group" style="position: relative;">
                <input
                  type="text"
                  class="form-control"
                  formControlName="physicalZip"
                  [readonly]="physicalZipReadonly"
                  (input)="onPhysicalZipInputChange($any($event.target).value)"
                  [class.is-invalid]="isInvalid('physicalZip')"
                  autocomplete="off"
                />

                <!-- Autocomplete dropdown -->
                <ul
                  *ngIf="physicalZipOptions.length > 1"
                  class="autocomplete-options list-unstyled border position-absolute w-100 bg-white p-0 m-0"
                  style="top: 100%; max-height: 150px; overflow-y: auto; z-index: 1000;"
                >
                  <li
                    *ngFor="let zip of physicalZipOptions"
                    (click)="selectPhysicalZip(zip)"
                    class="px-2 py-1"
                    style="cursor: pointer;"
                  >
                    {{ zip }}
                  </li>
                </ul>

                <div class="invalid-feedback" *ngIf="isInvalid('physicalZip')">
                  Campo requerido.
                </div>
              </div>
            </div>
            <!-- <div class="col-md-12">
               <label class="form-labels mt-4"
                >¿La dirección postal es igual que la fisica?</label
              ><br /> -->
              <!-- <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  [checked]="editData && addressSame"
                  type="radio"
                  name="inlineRadioOptions"
                  value="si"
                  name="select"
                  (change)="sameAddress($event)"
                />
                <label class="form-check-label">Si</label>
              </div> -->
              <!-- <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  [checked]="editData && !addressSame"
                  name="select"
                  type="radio"
                  value="no"
                  (change)="sameAddress($event)"
                />
                <label class="form-check-label">No</label>
              </div> 
            </div> -->

            <div
              class="row"
              *ngIf="showPostalAddress || (editData && !addressSame)"
            >
              <div class="col-md-12 mt-4">
                <h6>Dirección Postal</h6>
              </div>
              <div class="col-md-6">
                <label class="form-labels mt-4">Dirección linea 1</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    formControlName="postalAddress1"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-labels mt-4">Dirección linea 2</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    formControlName="postalAddress2"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-labels mt-4">Ciudad</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    formControlName="postalCity"
                  />
                </div>
                <!-- <select formControlName="physicalState" class="form-select">
                                <option selected></option>
                                <option [value]="city.Nombre" *ngFor="let city of cities">{{ city.Nombre }}
                                </option>
                            </select> -->
              </div>
              <div class="col-md-6">
                <label class="form-labels mt-4">Estado</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    formControlName="physicalState"
                    maxlength="2"
                    (change)="updatePostalState()"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-labels mt-4">Zip Code</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    formControlName="postalZip"
                  />
                </div>
              </div>
            </div>

            <div class="col-md-12 mt-4">
              <hr />
            </div>

      <div class="col-md-4">
        <mat-form-field appearance="outline" class="w-100 mt-4">
          <mat-label>Fecha de efectividad</mat-label>
          <input
            matInput
            [matDatepicker]="effPicker"
            formControlName="effectiveDate"
            placeholder="MM/DD/YYYY" />
          <mat-datepicker-toggle matSuffix [for]="effPicker"></mat-datepicker-toggle>
          <mat-datepicker #effPicker></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field appearance="outline" class="w-100 mt-4">
          <mat-label>Fecha de primer pago</mat-label>
          <input
            matInput
            [matDatepicker]="firstPicker"
            formControlName="dateFirstPay"
            (dateChange)="updateDomPay($event.value)"
            placeholder="MM/DD/YYYY" />
          <mat-datepicker-toggle matSuffix [for]="firstPicker"></mat-datepicker-toggle>
          <mat-datepicker #firstPicker></mat-datepicker>
        </mat-form-field>
      </div>


      <div class="col-md-4">
        <mat-form-field appearance="outline" class="w-100 mt-4">
          <mat-label>Fecha del último pago</mat-label>
          <input
            matInput
            [matDatepicker]="lastPicker"
            formControlName="dateLastPay"
            [disabled]="true"
            placeholder="MM/DD/YYYY" />
          <mat-datepicker-toggle matSuffix [for]="lastPicker"></mat-datepicker-toggle>
          <mat-datepicker #lastPicker></mat-datepicker>
        </mat-form-field>
      </div>
            </div><!-- End of shouldShowInsuredForm wrapper -->

            <div class="col-md-12">
              <button
                type="submit"
                class="btn btn-primary mt-4"
                (click)="createContract()"
                [disabled]="!canCreate || (!isUSVI && !shouldShowInsuredForm)"
              >
                Crear Contrato
              </button>

            </div>
            <div *ngIf="showMsg" style="color: rgb(255, 62, 62)">{{ msg }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card">
        <div class="card-body">
          <div class="row quote-res">
            <div class="col-12">
              <label class="form-labels">Prima</label>
              <div class="input-group flex-nowrap">
                $<input
                  type="number"
                  formControlName="qPremium"
                  [disabled]="true"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-12">
              <label class="form-labels mt-2">Pronto</label>
              <div class="input-group flex-nowrap">
                $<input
                  type="number"
                  formControlName="qDownPayment"
                  [disabled]="true"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-12">
              <label class="form-labels mt-2">A financiar</label>
              <div class="input-group flex-nowrap">
                $
                <input
                  type="number"
                  formControlName="qFinancingAmount"
                  [disabled]="true"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-12" *ngIf="showCompulsoryIns">
              <label class="form-labels mt-2">S / Obligatorio</label>
              <div class="input-group flex-nowrap">
                $<input
                  type="number"
                  formControlName="compulsoryIns"
                  [disabled]="true"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-12">
              <label class="form-labels mt-2">Plazo</label>
              <div class="input-group flex-nowrap">
                <input
                  type="number"
                  formControlName="qInstallments"
                  [disabled]="true"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-12">
              <label class="form-labels mt-2">Porciento de Interés (APR)</label>
              <div *ngIf="quoteData" class="input-group flex-nowrap">
                <input
                  type="number"
                  value="{{ quoteData.apr }}"
                  [disabled]="true"
                  [style.display]="lessThan20DisplayData.lessThan20APR ? 'none' : ''"
                  class="form-control"
                />
                <input
                  type="number"
                  value="{{ lessThan20DisplayData.lessThan20APR }}"
                  [disabled]="true"
                  [style.display]="!lessThan20DisplayData.lessThan20APR ? 'none' : ''"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-12">
              <label class="form-labels mt-2">Interes a pagar</label>
              <div class="input-group flex-nowrap">
                $<p *ngIf="quoteData.interesLessThan20">
                  20.00
                </p>
                <input
                  *ngIf="!quoteData.interesLessThan20"
                  type="number"
                  formControlName="qInterestPay"
                  [disabled]="true"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-12">
              <label class="form-labels mt-2">Total a Pagar</label>
              <div class="input-group flex-nowrap">
                $<input
                  type="number"
                  formControlName="qTotalPayment"
                  [disabled]="true"
                  [style.display]="lessThan20DisplayData.lessThan20Total ? 'none' : ''"
                  class="form-control"
                />
              <input
                type="number"
                [value]="lessThan20DisplayData.lessThan20Total"
                [disabled]="true"
                [style.display]="!lessThan20DisplayData.lessThan20Total ? 'none' : ''"
                class="form-control"
              />
              </div>
            </div>
            <div class="col-12">
              <label class="form-labels mt-2">Pago Mensual</label>
              <div class="input-group flex-nowrap">
                $<input
                  type="number"
                  formControlName="qInstallmentAmount"
                  [disabled]="true"
                  [style.display]="lessThan20DisplayData.pagoMensualLessThan20 ? 'none' : ''"
                  class="form-control"
                />
                <input
                  type="number"
                  [disabled]="true"
                  [value]="lessThan20DisplayData.pagoMensualLessThan20"
                  [style.display]="!lessThan20DisplayData.pagoMensualLessThan20 ? 'none' : ''"
                  class="form-control"
                >
              </div>
            </div>
            <div class="col-12">
              <label class="form-labels mt-2">Porciento de Interés Anual</label>
              <input
                type="number"
                formControlName="qAnnualPercent"
                [disabled]="true"
                [style.display]="lessThan20DisplayData.lessThan20APR ? 'none' : ''"
                class="form-control"
              />
              <input
                type="number"
                [value]="lessThan20DisplayData.lessThan20APR"
                [disabled]="true"
                [style.display]="!lessThan20DisplayData.lessThan20APR ? 'none' : ''"
                class="form-control"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="row">
    <div class="col-12" style="text-align: right;">
        <a routerLink="/quotation" class="btn btn-secondary mt-4">Back</a>
    </div>
</div> -->
</form>

<!-- <pdf-viewer  id="viewer" [src]="pdfSrc"></pdf-viewer> -->

<!-- <button (click)="download()">Download</button> -->

<!-- <a [href]="fileUrl" download="file.pdf">DownloadFile</a> -->
<div *ngIf="loading" class="d-flex justify-content-center loading-screen">
  <div class="spinner-border" role="status">
    <span class="sr-only"></span>
  </div>
</div>